import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { reactive, watch, computed, onBeforeUpdate, onMounted, onBeforeUnmount, onUpdated } from "vue";
import { useRoute } from "vue-router";
export default {
  props: ["questionInfo", "allAnswers", "skill"],
  setup(props, content) {
    //处理题目
    let itemText = computed(() => {
      let text = props.questionInfo.itemText;
      if (route.meta.skill == "S0" || props.skill == "S0") {
        if (text.indexOf("{{") == -1) {
          text = props.questionInfo.questionGroupList[0].questionList[0].questionStem;
          let questionNum = `<input type="text" value="${answer[props.questionInfo.questionGroupList[0].questionList[0].questionId]}" questionId="${props.questionInfo.questionGroupList[0].questionList[0].questionId}"/>`;
          if (text.indexOf("__") != -1) {
            let reg = new RegExp(/_+/, "g");
            text = text.replace(reg, questionNum);
            text = `<span style="background: #4bbbff;color:#fff;display:inline;border-radius:5px;min-width: 16px;height:15px;text-align:center;line-height:15px;padding: 2px 6px;font-size:14px">${props.questionInfo.menu}</span>` + text;
          } else {
            let reg = new RegExp(/<u[^>]*>(&nbsp;\s*)+<\/u>/, "g");
            text = text.replace(reg, questionNum);
            text = `<span style="background: #4bbbff;color:#fff;display:inline;border-radius:5px;min-width: 16px;height:15px;text-align:center;line-height:15px;padding: 2px 6px;font-size:14px">${props.questionInfo.menu}</span>` + text;
          }
        }
      }
      for (let i = 0;; i++) {
        if (text.indexOf("{{") == -1 && text.indexOf("__") == -1) break;
        let questionNum = "";
        if (text.indexOf("{{") != -1) {
          if (route.meta.skill == "S0" || props.skill == "S0") {
            questionNum = `<input type="text" value="${answer[props.questionInfo.questionGroupList[i].questionList[0].questionId]}" questionId="${props.questionInfo.questionGroupList[i].questionList[0].questionId}"/>`;
            text = `<span style="background: #4bbbff;color:#fff;display:inline;border-radius:5px;min-width: 16px;height:15px;text-align:center;line-height:15px;padding: 2px 6px;font-size:14px">${props.questionInfo.menu + i}</span>` + text.substring(0, text.indexOf("{{")) + questionNum + text.substr(text.indexOf("}}") + 2);
          } else {
            questionNum = `<span style="background: #4bbbff;color:#fff;display:inline;border-radius:5px;min-width: 16px;height:15px;text-align:center;line-height:15px;padding: 2px 6px;font-size:14px">${props.questionInfo.menu + i}</span><input type="text" value="${answer[props.questionInfo.questionGroupList[i].questionList[0].questionId]}" questionId="${props.questionInfo.questionGroupList[i].questionList[0].questionId}"/>`;
            text = text.substring(0, text.indexOf("{{")) + questionNum + text.substr(text.indexOf("}}") + 2);
          }
        } else {
          questionNum = `<span style="background: #4bbbff;color:#fff;display:inline;border-radius:5px;min-width: 16px;height:15px;text-align:center;line-height:15px;padding: 2px 6px;font-size:14px">${props.questionInfo.menu + i}</span><input type="text" value="${answer[props.questionInfo.questionGroupList[i].questionList[0].questionId]}" questionId="${props.questionInfo.questionGroupList[i].questionList[0].questionId}"/>`;
          text = text.substring(0, text.indexOf("__")) + questionNum + text.substr(text.lastIndexOf("__") + 2);
        }
      }
      return text;
    });
    let answer = reactive({});
    let route = useRoute();
    watch(props, () => {
      let list = {};
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        questionGroup.questionList.forEach(questionItem => {
          list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId] : "";
        });
      });
      for (let key in answer) {
        delete answer[key];
      }
      Object.assign(answer, list);
    }, {
      immediate: true
    });
    //更换题目
    watch(() => props.questionInfo, () => {
      document.getElementsByClassName("question")[0].scrollTop = 0;
      if (route.meta.skill == "S0") setAnswer();
    });
    onMounted(() => {
      let inputs = document.getElementsByTagName("input");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener("blur", setAnswer);
      }
      if (route.meta.skill == "S0") setAnswer();
    });
    onBeforeUnmount(() => {
      let inputs = document.getElementsByTagName("input");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].removeEventListener("blur", setAnswer);
      }
    });
    onUpdated(() => {
      let inputs = document.getElementsByTagName("input");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener("blur", setAnswer);
      }
    });
    onBeforeUpdate(() => {
      let inputs = document.getElementsByTagName("input");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].removeEventListener("blur", setAnswer);
      }
    });
    function setAnswer(e) {
      if (e) {
        answer[e.target.getAttribute("questionId")] = e.target.value.slice(0, 60);
      }
      content.emit("setAnswer", answer);
    }
    return {
      itemText
    };
  }
};